import React from 'react';

function Copyright() {
    return (
        <>
        <div class="container-fluid copyright text-light py-4 wow fadeIn" data-wow-delay="0.1s">
        <div class="container">
            <div class="row">
                <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
                    &copy; <a href="#">Revtech</a>, All Right Reserved.
                </div>
                {/* <div class="col-md-6 text-center text-md-end">
                     Designed By <a href="https://htmlcodex.com">HTML Codex</a>
                    <br />Distributed By: <a href="https://themewagon.com" target="_blank">ThemeWagon</a>
                </div> */}
            </div>
        </div>
    </div>
    </>
    )
}

export default Copyright;